import { withStyles } from "@material-ui/core";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import XAPPButton from "../Button/XAPPButton";
import * as Actions from "./Store/Actions";
import reducer from "./Store/Reducers";

const styles = theme => ({
    container: {
        width: 400,
        height: "100%",
        backgroundColor: theme.palette.background.default,
    }
});

const PainelFixoDireita = ({ classes, conteudo, changeContentPainel }) => {

    return (
        <React.Fragment>
            {!_.isNull(conteudo) && !document.location.pathname.includes("/pub-") &&
                <div className={clsx(classes.container)}>
                    <div className="flex w-full pl-24 h-48 border-l-1">
                        <div style={{ flex: 1 }} />
                        <XAPPButton
                            className="p-8 "
                            icon="close"
                            type="icon"
                            iconProps="text-24"
                            onClick={() => changeContentPainel()}
                        />
                    </div>
                    {conteudo}
                </div>
            }
        </React.Fragment >
    );
};


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeContentPainel: Actions.changeContentPainel,
    }, dispatch);
}

function mapStateToProps({ PainelFixo }) {
    return {
        conteudo: PainelFixo.conteudo,
    };
}

export default withReducer("PainelFixo", reducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(PainelFixoDireita))));